import { Standort } from '@/domain/mitarbeiter/features/anlageassistent/entities/Standort';
import {
  Tarifgruppen,
  Tarifvertrag,
  TarifvertragTyp,
} from '@/domain/mitarbeiter/features/anlageassistent/entities/Tarifvertrag';
import { Mitarbeiter_GetStandortByIdDocument } from '@/gql/graphql';
import { useSuspenseQuery } from '@apollo/client/react';

export function useStandort(
  standortId: string,
  gueltigAb?: Date,
): { standort: Standort | null } {
  const result = useSuspenseQuery(Mitarbeiter_GetStandortByIdDocument, {
    variables: {
      standortId,
      gueltigAb: gueltigAb?.toISOString(),
    },
  });

  if (result.error) {
    return {
      standort: null,
    };
  }

  const standortResult = result.data.mitarbeiter_standortById;

  return {
    standort: new Standort({
      id: standortResult.id,
      name: standortResult.name,
      tarifvertrag: standortResult.tarifvertrag
        ? new Tarifvertrag({
            id: standortResult.tarifvertrag.id,
            tarifvertragTyp:
              TarifvertragTyp[standortResult.tarifvertrag.tarifvertragTyp],
            tarifgruppen: standortResult.tarifvertrag.tarifgruppen.map(
              (tg) =>
                new Tarifgruppen({
                  id: tg.id,
                  gruppe: tg.gruppe,
                  gehalt: tg.gehalt,
                  stundenlohn: tg.stundenlohn,
                  gueltigAb: new Date(tg.gueltigAb),
                }),
            ),
          })
        : undefined,
    }),
  };
}
